··
<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {Get, Post, PostForm, baseURL1} from '@/util/http'
import {getToken, setToken,} from "@/util/auth";
import Cookies from 'js-cookie'
import {weosocketUrl} from '@/util/http'
import {ListToTree} from "@/util";
import {encode} from "@/util/Base64";
import store from "@/store";


export default {
  data() {
    return {
      uid: '',
      menu: [],
      state: 0,
    }
  },
  created() {

    this.getUserId()
    //shaogh  wangsy
    // this.uid = 'shill1'


    if (this.uid) {
      // this.$store.state.user.token = 'shill1'
      if (!this.$store.state.user.token) {
        this.getOAuser(this.uid)
      } else {
        this.getUserList()
        this.getDeptList()
        this.getAccessToken()
        this.getdictionaryAll()
        this.getCause()
        this.initWebSocket()
        this.getUserRole()
        // this.getMessageLogin()
        Post('/system/role/findUserRole').then(async res => {

          this.menu = await this.insertionSort(res.list.menu)
          sessionStorage.setItem('YINGFENG-MENU', JSON.stringify(res.list.menu))
          this.menu = this.toRee(this.menu)
          this.$store.commit('SET_MENU', this.menu)
            let type = localStorage.getItem('type')
            let whether = localStorage.getItem('whether')
            if (whether){
              this.passRouter(type);
            }
        })
      }
    } else {
      Post('/login').then(res => {
        if (res.code === 200) {
          if (!window.firstRequest) {
            window.firstRequest = true
            // let url = encodeURIComponent('https://fawutest.infore.com/#/wel/index')
            // window.location.href = `https://siamtest.infore.com/siam/oauth2.0/authorize?client_id=AUTH_FWHG1&redirect_uri=${url}&response_type=code`
            let url = encodeURIComponent('https://ils.infore.com/#/wel/index')
            window.location.href = `https://login.infore.com/siam/oauth2.0/authorize?client_id=ils_pc&redirect_uri=${url}&response_type=code`
          }
        } else {
          this.$message.error('获取用户信息失败')
          setTimeout(() => {
            // let url = encodeURIComponent('https://fawutest.infore.com/#/wel/index')
            // window.location.href = `https://siamtest.infore.com/siam/oauth2.0/authorize?client_id=AUTH_FWHG1&redirect_uri=${url}&response_type=code`
            let url = encodeURIComponent('https://ils.infore.com/#/wel/index')
            window.location.href = `https://login.infore.com/siam/oauth2.0/authorize?client_id=ils_pc&redirect_uri=${url}&response_type=code`
          })
        }
      })
    }
  },
  methods: {
    //OA页面跳转到系统指定页面
    passRouter(type){
      let id = localStorage.getItem('id')
      let code = localStorage.getItem('code')
      let subjection = localStorage.getItem('subjection')
      let state = localStorage.getItem('state')
      let currentState = localStorage.getItem('currentState')
      let whether = localStorage.getItem('whether')
      let url="";
      if (type == 1) {
        url = '/cases/details'
      } else if (type == 2) {
        url = '/preservation/details'
      } else if (type == 3) {
        url = '/preservation/handleRelieve'
      } else if (type == 4) {
        url = '/arbitration/details'
      } else if (type == 5) {
        url = '/firstInstance/details'
      } else if (type == 6) {
        url = '/secondInstance/details'
      } else if (type == 7) {
        url = '/arbitration/preArbitrationDetails'
      } else if (type == 8) {
        url = '/caseExecution/details'
      } else if (type == 9) {
        url = '/caseClosed/details'
      } else if (type == 10) {
        url = '/retrial/details'
      } else if (type == 11 || type == 12 || type == 13 || type == 14 || type == 15 || type == 19 || type == 20) {
        url = '/caseProcess/details'
      } else if (type == 17) {
        url = '/externalLawyer/details'
      } else if (type == 18) {
        url = '/externalLawyer/change'
      } else if (type == 21) {
        url = '/shares/details'
      } else if (type == 22) {
        url = '/shares/secondDetails'
      } else if (type == 23) {
        url = '/Information/disclosure'
      } else if (type == 24) {
        url = '/Information/details'
      } else if (type == 25) {
        url = '/securities/pool_application'
      } else if (type == 26) {
        url = '/securities/third_detail'
      } else if (type == 27) {
        url = '/securities/details'
      } else if (type == 28) {
        url = '/securities/secondDetails'
      } else if (type == 32) {
        url = '/complianceDeclare/details'
      } else if (type == 33) {
        url = '/complianceToPush/details'
      } else if (type == 34) {
        url = '/litigation/lawyerDetails'
      } else if (type == 35) {
        url = '/litigation/lawFirmLibraryDetail'
      } else if (type == 36) {
        url = '/litigation/lawyerEvaluationDetail'
      } else if (type == 37) {
        url = '/litigation/lawFirmEvaluationDetail'
      } else if (type == 40) {
        url = '/file/detail'
      } else if (type == 41) {
        url = '/riskItem/detail'
      } else if (type == 42) {
        url = '/complianceudits/details'
      } else if (type == 43) {
        url = '/complianceAudit/details'
      } else if (type == 50) {
        url = '/caseExecution/resumingExecution'
      } else if (type == 100) {
        url = '/transition/transition_detail'
      } else if (type == 51) {
        url = '/supplementaryApproval/index'
      }
      this.$store.state.user.isCloseTip=false
      let query={
        type,
        id,
        code,
        subjection,
        state,
        currentState,
        whether
      }
      if(type==51){

        delete query.id
        query.uid=id
      }
      this.$router.replace({
        path: url,
        query: query
      })
      setTimeout(() => {
        localStorage.removeItem('pathValue')
        localStorage.removeItem('type')
        localStorage.removeItem('id')
        localStorage.removeItem('code')
        localStorage.removeItem('subjection')
        localStorage.removeItem('state')
        localStorage.removeItem('currentState')
      }, 2000)
    },
    /**获取table数据 */
    async getDeptList1() {
      this.loading = true
      await Post("/system/organizational/findAll").then(({code, list}) => {
        if (code === 200) {
          //List转Tree
          this.loading = false
          this.$store.state.common.dictionary.department = ListToTree(list)


        }
      })
    },
    getOAuser(code) {
      let url = ''
      let obj = {}
      if (this.state == 1) {
        url = '/login/token'
        obj = {
          code: code
        }
      } else if (this.state == 2) {
        url = '/login/tokenByUser'
        obj = {
          token: this.uid
        }
      }
      PostForm(url, obj).then(res => {
        if (res.code === 200) {
          if (res.user.error) {
            this.$message.error('该用户查找失败，请重新登录')
            setTimeout(() => {
              // let url = encodeURIComponent(`https://fawutest.infore.com/#/wel/index`)
              let url = encodeURIComponent(`https://ils.infore.com/#/wel/index`)
              // window.location.href = `https://siamtest.infore.com/siam/oauth2.0/authorize?client_id=AUTH_FWHG1&redirect_uri=${url}&response_type=code`
              window.location.href = `https://login.infore.com/siam/oauth2.0/authorize?client_id=ils_pc&redirect_uri=${url}&response_type=code`
             })
          } else {
            setToken(res.user.id ? res.user.id : res.user.attributes[0].uid)
            let userId = res.user.id ? res.user.id : res.user.attributes[0].uid
            let userToken = res.token ? res.token : this.uid
            this.$store.commit('SET_TOKEN', userId)
            this.$store.commit('SET_UID', userToken)
            Cookies.set('SIAMTGT', userToken)
            this.getUserList()
            this.getDeptList()
            this.getAccessToken()
            this.getdictionaryAll()
            this.initWebSocket()
            this.getUserRole()
            // this.getMessageLogin()
            Post('/system/role/findUserRole').then(async res => {

              sessionStorage.setItem('YINGFENG-MENU', JSON.stringify(res.list.menu))
              this.menu = await this.insertionSort(res.list.menu)
              this.menu = this.toRee(this.menu)
              this.$store.commit('SET_MENU', this.menu)
                let type = localStorage.getItem('type')
                let whether = localStorage.getItem('whether')
                if (whether){
                  this.passRouter(type);
                }
                // this.$router.replace({
                //   path: path,
                //   query: {
                //     type,
                //     id,
                //     code,
                //     subjection,
                //     state,
                //     currentState
                //   }
                // })
            })
          }
        }
      })
    },
    //  获取用户角色是否为超管
    getUserRole() {
      Post('/system/role/superAdmin').then(res => {
        if(res.code == 200) {
          this.$store.commit('SET_ROLE', res.list)
        }
      })
    },
    //    获取申请单位
    getDeptList() {
      Post('/system/company/queryAll').then(res => {
        if (res.code === 200) {
          this.$store.commit('SET_APPLICANT', res.data)
        }
      })
    },

    getUserList() {
      PostForm('/system/user/findById', {
        id:  encode(this.$store.state.user.token)
      }).then(res => {
        if (res.code === 200) {
          this.$store.commit('SET_USERNAME', res.list.cn)
          this.$store.commit('SET_DEPNAME', res.list.deptEntity.departmentName)
          this.$store.commit('SET_DEPTID', res.list.deptEntity.departmentNumber)
        }
      })
    },
    getAccessToken() {
      PostForm('/workFlow/getAccessToken', {
        userId: this.$store.state.user.token
      }).then(res => {
        if (res.code === 200) {
          this.$store.commit('SET_ACCESSTOKEN', res.data)
        }
      })
    },
    async getdictionaryAll() {
      const {list} = await Post('/system/dictionary/queryAll', {type: ''})
      this.$store.state.common.dictionary = {
        department: [],
        trialAay: [],
        flieType: [],
        reviewStatus: [],
        recordTypeList: [],
        courtList: [],
        causeActionList: [],
        guaranteeType: [],
        permissions: [],
        caseProgress: [],
        LawCaseTypeOption: [],
        controversy: [],
        settlementWay: [],
        ApplyForItems: [],
        is: [],
        businessSector: [],
        LimitationLiability: [],
        ourPositionOption: [],
        arbitrationTribunal: [],
        unit: [],
        arbitratingIdentity: [],
        secondIdentity: [],
        Participants: [],
        RulingWay: [],
        country: [],
        agent: [],
        complianceRisk: [],
        ExecutionStatus: [],
        arbitrationAward: [],
        recoveryTime: [],
        riskItems: [],
        educationBackground: [],
        goodAtField: [],
        isHeadOffice: [],
        lawFirms: [],
        identityAgent: [],
        describe: [],
        complianceRiskAll: [],
        executionOfApplication: [],
        arbitrationTribunalL: [],
        identityAll: [],
        courtLst: [],
        lawFirmsList: [],
      }
      list.find(item => {
        let data = item
        data.label = item.name
        data.value = item.value
        if (item.type == '36' || item.type == '37') {
          data.id = item.value
          data.recordName = item.name
        }
        if (item.type == '1') this.$store.state.common.dictionary.recordTypeList.push(data)
        if (item.type == '2') this.$store.state.common.dictionary.causeActionList.push(data)
        if (item.type == '4') this.$store.state.common.dictionary.guaranteeType.push(data)
        if (item.type == '5') this.$store.state.common.dictionary.permissions.push(data)
        if (item.type == '6') this.$store.state.common.dictionary.caseProgress.push(data)
        if (item.type == '7') this.$store.state.common.dictionary.LawCaseTypeOption.push(data)
        if (item.type == '8') this.$store.state.common.dictionary.controversy.push(data)
        if (item.type == '9') this.$store.state.common.dictionary.settlementWay.push(data)
        if (item.type == '10') this.$store.state.common.dictionary.ApplyForItems.push(data)
        if (item.type == '11') this.$store.state.common.dictionary.is.push(data)
        if (item.type == '12') this.$store.state.common.dictionary.businessSector.push(data)
        if (item.type == '13') this.$store.state.common.dictionary.LimitationLiability.push(data)
        if (item.type == '14') this.$store.state.common.dictionary.ourPositionOption.push(data)
        if (item.type == '15') this.$store.state.common.dictionary.reviewStatus.push(data)
        if (item.type == '16') this.$store.state.common.dictionary.flieType.push(data)
        if (item.type == '17') this.$store.state.common.dictionary.trialAay.push(data)
        if (item.type == '18') this.$store.state.common.dictionary.unit.push(data)
        if (item.type == '19') this.$store.state.common.dictionary.arbitratingIdentity.push(data)
        if (item.type == '20') this.$store.state.common.dictionary.country.push(data)
        if (item.type == '21') this.$store.state.common.dictionary.secondIdentity.push(data)
        if (item.type == '22') this.$store.state.common.dictionary.RulingWay.push(data)
        if (item.type == '23') this.$store.state.common.dictionary.Participants.push(data)
        if (item.type == '24') this.$store.state.common.dictionary.agent.push(data)
        if (item.type == '25') this.$store.state.common.dictionary.ExecutionStatus.push(data)
        if (item.type == '26') this.$store.state.common.dictionary.arbitrationAward.push(data)
        if (item.type == '29') this.$store.state.common.dictionary.recoveryTime.push(data)
        if (item.type == '30') this.$store.state.common.dictionary.educationBackground.push(data)
        if (item.type == '31') this.$store.state.common.dictionary.goodAtField.push(data)
        if (item.type == '32') this.$store.state.common.dictionary.isHeadOffice.push(data)
        if (item.type == '34') this.$store.state.common.dictionary.identityAgent.push(data)
        if (item.type == '35') this.$store.state.common.dictionary.executionOfApplication.push(data)
        if (item.type == '36') this.$store.state.common.dictionary.courtLst.push(data)
        if (item.type == '37') this.$store.state.common.dictionary.arbitrationTribunalL.push(data)
        if (item.type == '38') this.$store.state.common.dictionary.identityAll.push(data)

      })
      this.getMenu()
      this.getarbitrationTribunal()
      this.getCause()
      this.getDeptList1()
      this.getcomplianceWarehouse()
      this.getcomplianceWarehouseAll()
      this.lawFirmsAll()
      this.$store.state.common.dictionary.country = await this.sort(this.$store.state.common.dictionary.country)
      this.$store.state.common.dictionary.unit = await this.sort1(this.$store.state.common.dictionary.unit)
      this.$store.state.common.dictionary.declareSubject = this.$store.state.common.declareSubject
    },
    lawFirmsAll() {
      Post('caseLawFirm/queryAll', {
        menuId: '25',
      }).then(res => {
        let list = []
        res.list.find(item => {
          item.lawyers.find(item => {
            item.value = item.id
            item.label = item.name
          })
          list.push({
            label: item.lawName,
            value: item.id,
            lawyers: item.lawyers,
            count: item.count
          })
        })
        this.$store.state.common.dictionary.lawFirmsList = list

      })
    },
    getcomplianceWarehouseAll() {
      Post('/complianceWarehouse/queryAll', {}).then((res) => {
        res.list.find(item => {
          let list = []

          if (item.riskName.length > 0) {
            item.riskName.find(items => {
              let List = []
              items.list.find(item1 => {
                List.push({
                  label: item1.name,
                  value: item1.id,
                })
              })
              list.push({
                label: items.name,
                value: items.id,
                children: List,
              })
              if (items.list.length > 0) {
                this.$store.state.common.dictionary.describe.push(...List)
              }


            })

          }
          this.$store.state.common.dictionary.complianceRiskAll.push({
            label: item.riskType,
            value: item.id,
            children: list
          })
          this.$store.state.common.dictionary.riskItems.push(...list)
        })

      })
    },
    getcomplianceWarehouse() {
      Post('/complianceWarehouse/queryAll', {state: '1'}).then((res) => {
        res.list.find(item => {
          let list = []

          if (item.riskName.length > 0) {
            item.riskName.find(items => {
              let List = []
              items.list.find(item1 => {
                List.push({
                  label: item1.name,
                  value: item1.id,
                })

              })
              list.push({
                label: items.name,
                value: items.id,
                children: List,
              })
            })

          }
          this.$store.state.common.dictionary.complianceRisk.push({
            label: item.riskType,
            value: item.id,
            children: list
          })

        })

      })
    },
    getMessageLogin() {
      Post('/system/message/login').then(res => {
      })
    },
    initWebSocket() { //初始化weosocket
      const wsuri =
          // 'ws://localhost:8090/webMessage/' + this.$store.state.token
          weosocketUrl + this.$store.state.user.token
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen() { //连接建立之后执行send方法发送数据
      console.log("成功")
    },
    websocketonerror() {//连接建立失败重连
      this.initWebSocket()
    },
    websocketsend(Data) {//数据发送
      this.websock.send(Data)
    },
    websocketclose(e) {  //关闭
      console.log('断开连接', e)
    },
    //获取仲裁庭
    async getarbitrationTribunal() {
      const {list} = await PostForm('/caseClosure/queryCourt', {
        type: '1',
      })
      this.$store.state.common.dictionary.arbitrationTribunal = list
    },
    //获取法院
    async getMenu() {
      const {list} = await PostForm('/caseClosure/queryCourt', {
        type: '0',
      })
      this.$store.state.common.dictionary.courtList = list

    },
    async getCause() {
      const {list} = await Post('/system/dictionary/queryAll', {
        type: '2'
      })
      let CauseList = []
      let List
      List = await this.sort1(list)
      List.find(item => {
        let data = item
        data.label = item.name
        data.value = item.id
        if (item.type == '2') CauseList.push(data)
      })
      this.$store.state.common.dictionary.causeActionList = CauseList


      this.$store.state.common.dictionary.causeAction = this.toRee1(CauseList)
    },
    async isArr(list) {
      if (list.length > 0) {
        list = await this.insertionSort(list)
        for (let i in list) {
          if (list[i].children.length > 0) {
            list = this.insertionSort(list[i].children)
          }
        }

      }
      return list
    },
    //排序
    insertionSort(arr) {
      return new Promise((resolve) => {
        arr.filter(res=> res.hidden != 1)
        const len = arr.length;
        let preIndex, current;
        for (let i = 1; i < len; i++) {
          preIndex = i - 1;
          current = arr[i];
          while (preIndex >= 0 && arr[preIndex].sort > current.sort   ) {
            arr[preIndex + 1] = arr[preIndex];
            preIndex--;
          }
          arr[preIndex + 1] = current;
        }
        resolve(arr)
      })
    },
    //国别排序
    sort(arr) {
      return new Promise((resolve) => {
        const len = arr.length;
        let preIndex, current;
        for (let i = 1; i < len; i++) {
          preIndex = i - 1;
          current = arr[i];
          while (Number(preIndex >= 0 && arr[preIndex].id) > Number(current.id)) {
            arr[preIndex + 1] = arr[preIndex];
            preIndex--;
          }
          arr[preIndex + 1] = current;
        }
        resolve(arr)
      })
    },
    //国别排序
    sort1(arr) {
      return new Promise((resolve) => {
        const len = arr.length;
        let preIndex, current;
        for (let i = 1; i < len; i++) {
          preIndex = i - 1;
          current = arr[i];
          while (Number(preIndex >= 0 && arr[preIndex].value) > Number(current.value)) {
            arr[preIndex + 1] = arr[preIndex];
            preIndex--;
          }
          arr[preIndex + 1] = current;
        }
        resolve(arr)
      })
    },
    //递归 生成 数组
    toRee(list, pid = null) {
      let newList = list.filter(it => it.pid === pid && it.hidden != 1)
      newList.forEach(it => it.children = this.toRee(list, it.id))
      return newList
    },
    //递归 生成 数组
    toRee1(list, pid = null) {
      let newList = list.filter(it => it.pid === pid)
      newList.forEach(it => it.children = this.toRee1(list, it.value))
      return newList.length < 1 ? undefined : newList
    },
    async getUserId() {
      let falg = false;
      let query = window.location.hash.substring(1);
      let vars = query.split("?");
      if (vars[1] && vars[1].indexOf('&') > -1) {
        localStorage.setItem('pathValue', vars[0])
        let pair = vars[1].split("&");
        let obj = {}
        pair.filter(item => {
          if (item.indexOf('=') > -1) {
            let itemArr = item.split('=')
            if (itemArr[0] === 'type') {
              obj.type = itemArr[1]
            } else if (itemArr[0] === 'id') {
              obj.id = itemArr[1]
            } else if (itemArr[0] === 'code') {
              obj.code = itemArr[1]
            } else if (itemArr[0] === 'subjection') {
              obj.subjection = itemArr[1]
            } else if (itemArr[0] === 'state') {
              obj.state = itemArr[1]
            } else if (itemArr[0] === 'currentState') {
              obj.currentState = itemArr[1]
            }else if (itemArr[0] === 'whether') {
              obj.whether = itemArr[1]
            }
          }
        })
        localStorage.setItem('type', obj.type)
        localStorage.setItem('id', obj.id)
        localStorage.setItem('code', obj.code)
        localStorage.setItem('subjection', obj.subjection)
        localStorage.setItem('state', obj.state)
        localStorage.setItem('currentState', obj.currentState)
        localStorage.setItem('whether', obj.whether)
      }
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == 'code') {
          falg = true;
          this.state = 1
          let getUser = pair[1].split('&')
          this.uid = getUser[0]
          return getUser[0]
        }
      }
      if (Cookies.get('SIAMTGT') && Cookies.get('SIAMTGT') != undefined) {
        let token = Cookies.get('SIAMTGT')
        this.uid = Cookies.get('SIAMTGT')
        this.state = 2
        return token
      }
      if (!falg) {
        let token = this.$store.state.user.token
        if (token) {
          this.uid = token
          return token
        }
      }
      // if(Cookies.get('SIAMTGT')) {
      //   let token = Cookies.get('SIAMTGT')
      //   this.uid = Cookies.get('SIAMTGT')
      //   this.state = 2
      //   return token
      // }
      return (false)
    }
  }
}
</script>

<style lang="scss">
/* Chrome浏览器 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/* Firefox浏览器 */
input[type="number"] {
  -moz-appearance: textfield;
}

#app {
  overflow: hidden;
  height: 100%;
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

}

nav {
  padding: 30px !important;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
